import React from 'react';

const Home = () => {
  return (
    <div>
      <h2>Is Your Website Accessible to Everyone?</h2>
      <p>In today's digital age, ensuring that your website is accessible to all users is not just a legal requirement but a moral obligation. Accessibility means that your site can be used by people of all abilities and disabilities, providing an inclusive experience for everyone.</p>

      <h2>Why Accessibility Matters</h2>
      <p>Web accessibility is about making sure everyone, including people with disabilities, can perceive, understand, navigate, and interact with your website. By adhering to the Web Content Accessibility Guidelines (WCAG) 2.0, you ensure that your content is accessible to a wider audience, improving user experience and broadening your reach.</p>

      <h2>How Our Tool Helps</h2>
      <p>Our AI-powered Web Accessibility Checker evaluates your website against the WCAG 2.0 guidelines. It identifies areas where your site may not be compliant and provides actionable suggestions to enhance accessibility. Here’s what our tool offers:</p>

      <p><h4>Automated Accessibility Audits:</h4> Quickly assess your website's accessibility status.</p>
      <p><h4>Detailed Reports:</h4> Understand specific issues and the guidelines they relate to.</p>
      <p><h4>Improvement Suggestions:</h4> Get clear, actionable recommendations to make your site more accessible.</p>
      <h2>Get Started</h2>
      <p>Ready to ensure your website is accessible to everyone? Click the link below to check if your site meets the WCAG 2.0 standards and receive tailored suggestions on how to improve accessibility.</p>
    </div>
  );
};

export default Home;

